import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.Xero.XeroCisDeductionInvoice', {
    cisTaxAmount: 'CIS Deduction ({percent}%):',
});
